/* global axios */
import ApiClient from './ApiClient';

class KanbanStagesAPI extends ApiClient {
  constructor() {
    super('kanban_stages', { accountScoped: true });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }
}

export default new KanbanStagesAPI();
